import { gql } from "@apollo/client";

export const fetchHoldKavaOffers = gql`
  query FetchHoldKavaOffers($input: HoldKavaOffersInput) {
    fetchHoldKavaOffers(input: $input) {
        id
        offer_id
        insurersinsurer_id
        rate
        commission
        commission_amount
        brokerage
        facultative_offer
        sum_insured
        fac_sum_insured
        premium
        fac_premium
        offer_drawer
        offer_status
        expiry_status
        closed_date
        offer_from
        place_it_id
        delete_status
        created_at
        updated_at
        classofbusiness {
          class_of_business_id
          business_name
          business_details
          business_category
          delete_status
          created_at
          updated_at
        }
        class_of_business {
          class_of_business_id
          business_name
          business_details
          business_category
          delete_status
          created_at
          updated_at
        }
        insurer {
          insurer_id
          insurer_company_name
          insurer_company_email
        }
        offer_detail {
          offer_detail_id
          offersoffer_id
          policy_number
          insured_by
          currency
          offer_comment
          offer_details
          period_of_insurance_from
          period_of_insurance_to
        }
        offer_published {
          offer_published_id
          published_status
          employeesemployee_id
          updated_by
          time_of_expiry
          created_at
          updated_at
          status
          is_upcoming_renewal
          participated_by
          published_by
        }
        hold_kava_participant {
          id
          offersoffer_id
          reinsurersreinsurer_id
          reinsurer_representative_id
          decision
          created_at
        }
      }
  }
`;
